import {
  HTTP_BUDGETS_FETCHING,
  HTTP_BUDGETS_SUCCESS,
  HTTP_BUDGETS_FAILED,
} from "././../../Constants";

const initialState = {
  result: [],
  invest: [],
  subbtn: 0,
  appid: 0,
  actid: 0,
  sid: 0,
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_BUDGETS_FETCHING:
      return {
        ...state,
        result: [],
        invest: [],
        subbtn: 0,
        appid: 0,
        actid: 0,
        sid: 0,
        isFetching: true,
        isError: false,
      };
    case HTTP_BUDGETS_SUCCESS:
      return {
        ...state,
        result: payload.data,
        invest: payload.invest,
        appid: payload.appid,
        actid: payload.actid,
        sid: payload.id,
        isFetching: false,
        isError: false,
      };
    case HTTP_BUDGETS_FAILED:
      return {
        ...state,
        subbtn: 0,
        appid: 0,
        actid: 0,
        sid: 0,
        result: [],
        invest: [],
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
